module.exports = __webpack_public_path__ + "img/logo-m.23afb3fd.svg";